import React from 'react';
import { AppFormBirthDateInput } from '../../../components/common/appForms';
import Icon from '../../../components/common/Icon/Icon';
import type { MedicalExamFile } from '../../../types/medicalExams';
import { formatExamFileSize, formatExamFileTypeLabel } from '../medicalExams.utils';
import styles from './ExamFileCard.module.css';

interface ExamFileCardProps {
  file: MedicalExamFile;
  dateError?: string;
  disabled?: boolean;
  onPreview: () => void;
  onRemove: () => void;
  onExamDateChange: (examDate: string) => void;
}

const ExamFileCard: React.FC<ExamFileCardProps> = ({
  file,
  dateError,
  disabled = false,
  onPreview,
  onRemove,
  onExamDateChange,
}) => (
  <article className={styles.card}>
    <button
      type="button"
      className={styles.thumbnailButton}
      onClick={onPreview}
      aria-label={`Visualizar ${file.fileName}`}
    >
      {file.kind === 'image' ? (
        <img src={file.previewUrl} alt="" className={styles.thumbnail} />
      ) : (
        <span className={styles.thumbnailPlaceholder}>
          <Icon name="picture_as_pdf" size={28} color="var(--color-text-muted)" />
        </span>
      )}
    </button>

    <div className={styles.content}>
      <h2 className={styles.title} title={file.fileName}>{file.fileName}</h2>
      <p className={styles.meta}>
        {formatExamFileTypeLabel(file.mimeType)}
        {' · '}
        {formatExamFileSize(file.sizeBytes)}
      </p>
      <div className={styles.dateField}>
        <AppFormBirthDateInput
          id={`exam-date-${file.id}`}
          label="Data do exame"
          value={file.examDate}
          error={dateError}
          required
          disabled={disabled}
          plainCalendarButton
          onChange={onExamDateChange}
        />
      </div>
    </div>

    <div className={styles.actions}>
      <button type="button" className={styles.previewLink} onClick={onPreview}>
        Visualizar
      </button>
      <button
        type="button"
        className={styles.removeButton}
        onClick={onRemove}
        aria-label={`Remover ${file.fileName}`}
        title="Remover"
        disabled={disabled}
      >
        <Icon name="delete" size={18} color="var(--color-error)" />
      </button>
    </div>
  </article>
);

export default ExamFileCard;
